import { render, staticRenderFns } from "./html/AAlert.html?vue&type=template&id=37f51dc8&lang=html&external"
import script from "./js/AAlert.js?vue&type=script&lang=js&external"
export * from "./js/AAlert.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports